import React from "react";
import { useRouter } from "@tanstack/react-router";
import { termsOfUseConsentGetMe } from "./api/generated/sASOnlineClinicBackendAPI";
import StatusScreen from "../components/StatusScreen";
import { messages } from "../utils/i18n/messages";

const SS_KEY_PREFIX = "termsOfUseAgreed:";

export function ClinicTermsOfUseGuard({
  children,
}: {
  children: React.ReactNode;
}) {
  const router = useRouter();
  const [ready, setReady] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    let cancelled = false;
    async function check() {
      try {
        const key = SS_KEY_PREFIX + "me";
        const cached = sessionStorage.getItem(key);
        if (cached === "true") {
          setReady(true);
          return;
        }
        const resp = await termsOfUseConsentGetMe();
        if (cancelled) return;
        if (resp && (resp as any).status === 200) {
          const agreed = Boolean((resp as any).data?.agreed);
          if (agreed) {
            sessionStorage.setItem(key, "true");
            setReady(true);
          } else {
            const currentPath =
              window.location.pathname + window.location.search;
            router.navigate({
              to: "/clinic/terms-of-use",
              search: { redirect: currentPath } as any,
            });
          }
        } else {
          setError(messages.TERMS_CONSENT_FETCH_ERROR);
        }
      } catch {
        setError(messages.TERMS_CONSENT_FETCH_ERROR);
      }
    }
    check();
    return () => {
      cancelled = true;
    };
  }, [router]);

  if (error) return <StatusScreen type="error" message={error} fullScreen />;
  if (!ready) return null;
  return <>{children}</>;
}

export default ClinicTermsOfUseGuard;
